// lib
import html2canvas from 'html2canvas';
import JSPDF from 'jspdf';
import autoTable from "jspdf-autotable";


export const printToPDFReport = (reportNamePrefix, data) => {
  const doc = new JSPDF("l", "pt", "a4"); // landscape, points, A4 size

  // Define table headers
  const head = [[
    "No",
    "Teacher Name",
    "Lessons",
    "Lessons per type",
    "Private Lessons Hours",
    "Private Lessons Rate Type",
    "Private Lessons Rate",
    "Private Lessons Lesson Total",
    "Class Group Hours",
    "Class Group Rate Type",
    "Class Group Rate",
    "Class Group Lesson Total",
    "Total owed"
  ]];
  // Map your `data` into rows
  const body = data?.results?.map((item, i) => [
    i + 1,
    item.teacherName,
    item.lessons,
    `${item?.private_lessons || 0} - Private lessons\n${item?.class_group_lessons || 0} - Class group lesson`,
    item?.private_lessons_hours,
    item?.private_lessons_rate_type,
    `$${item?.private_lessons_rate}`,
    `$${item?.private_lessons_totalOwed}`,
    item?.class_group_lessons_hours,
    item?.class_group_rate_type,
    `$${item?.class_group_rate}`,
    `$${item?.class_group_totalOwed}`,
    `$${item?.totalOwed}`,
  ]);

  // Build the table
  autoTable(doc, {
    head,
    body,
    startY: 20,
    theme: "grid",
    styles: {
      fontSize: 8,
      cellPadding: 3,
    },
    headStyles: {
      fillColor: [220, 220, 220], // light gray header
    },
  });

  // Save the PDF
  doc.save(`${reportNamePrefix}_${new Date().getTime()}.pdf`);
};


export const printToPDF = async (reportNamePrefix, printArea = 'printArea') => {
  const area = document.getElementById(printArea);
  return html2canvas(area, {
    scale: 1.5,
    logging: false,
    backgroundColor: '#FFFFFF',
  }).then(canvas => {
    const imgData = canvas.toDataURL('image/png');
    const orientation = canvas.width > canvas.height ? 'l' : 'p';
    const pdf = new JSPDF(orientation, 'px', [
      canvas.width + 20,
      canvas.height + 20,
    ]);
    const width = pdf.internal.pageSize.getWidth();
    const height = pdf.internal.pageSize.getHeight();
    pdf.setFillColor('#FFFFFF');
    pdf.rect(0, 0, width, height, 'F');
    pdf.addImage(imgData, 'JPEG', 10, 10, width - 20, height - 20, '', 'FAST');
    pdf.save(`${reportNamePrefix}_${new Date().getTime()}.pdf`);
  });
};
export const printToPDFMultiple = async (reportOwner, areas) => {
  let doc;
  let i = 0;
  await areas.reduce(async prevPromise => {
    return prevPromise.then((canvas = '') => {
      if (canvas !== '') {
        const orientation = canvas.width > canvas.height ? 'l' : 'p';
        if (!doc) {
          doc = new JSPDF(orientation, 'px', [
            canvas.height + 20,
            canvas.width + 20,
          ]);
        }
        if (i > 0) {
          doc.addPage([canvas.width + 20, canvas.height + 20], orientation)
        }
        const width = doc.internal.pageSize.getWidth();
        const height = doc.internal.pageSize.getHeight();


        doc.setFillColor(235, 235, 235);
        doc.rect(0, 0, width, height, 'F');


        doc.addImage(
          canvas.toDataURL('image/png'),
          'JPEG',
          10,
          10,
          width - 20,
          height - 20,
          '',
          'FAST',
        );
        if (i === areas.length - 1) {
          doc.save(`${reportOwner}_Assessment_Report`);
          return Promise.resolve();
        }


        i += 1;


        return html2canvas(document.getElementById(areas[i]), {
          scale: 1,
          logging: false,
          useCORS: true
        });
      }
      return Promise.resolve();
    });
  }, html2canvas(document.getElementById(areas[0]), {
    scale: 1, logging: false, useCORS: true
  }));
};